import {
  Box,
  Button,
  Container,
  Grid,
  makeStyles,
  Typography,
  useTheme,
} from "@material-ui/core";
import {
  Avatar,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Link,
  DialogTitle,
  withStyles,
  Divider,
} from "@material-ui/core";

import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import React, { useEffect, useState } from "react";
import DataService from "../../../Service";
import DocCard from "./DocCard";
import { ObjectToFormdata } from "../../../Common/Utils/common_utils";
import GetAppIcon from "@material-ui/icons/GetApp";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularIndeterminate from "../../../Components/Loader";

function SupportingDocs() {
  const classes = useStyles();
  const [supportingDocuments, setSupportingDocuments] = useState([]);
  const [programDocuments, setProgramDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [docData, setDocData] = useState([]);
  const [organisationFile, setOrganisationFile] = useState([]);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [currentID, setcurrentID] = useState(0);

  let urlElements = window.location.href.split("/");
  const InvoiceID = `${urlElements[5]}`;
  const getData = () => {
    const params = {
      invoice_id: InvoiceID,
    };
    DataService.getDirectData(`/invoices/listing_supporting_documents`, params)
      .then((response) => {
        setSupportingDocuments(response.supporting_documents);
        if(response.Programs_documents){
          setProgramDocuments(response.Programs_documents);
          
        }
        setLoading(false);
      })

      .catch((err) => { });
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, []);
  console.log(`organisationFile`, organisationFile);
  const uploadDoc = (event, id) => {
    setLoading(true);
    var postData = {
      invoice_id: InvoiceID,
      documents: [...event.target.files],
    };
    DataService.createData(
      ObjectToFormdata({ ...postData }),
      "upload_supporting_document"
    )
      .then((response) => {
        setLoading(false);
        getData()
        var localArr = [];
        localArr.push(supportingDocuments);
        setDocData(docData.concat(localArr));
      })
      .catch(() => { });
  };

  const deleteDoc = (id) => {
    setLoading(true);

    DataService.deleteDirectFeild(
      "invoices/delete_supporting_document?invoice_id=" +
      InvoiceID +
      "&document_id=" +
      id,
      {}
    )
      .then((response) => {
        setLoading(false);
        getData()
        var localArr = docData.filter((option) => option.id != id);
        docData.length = 0;
        setDocData(docData.concat(localArr));
        // dispatch(showSnackbar("Success", ["File removed successfully"]));
      })
      .catch(() => { });
  };
  const handleClickConfirmationOpen = () => {
    setConfirmationDialogOpen(true);
  };
  const handleConfirmationClose = () => {
    setConfirmationDialogOpen(false);
  };
  return (
    <div>
      <Container>
        <Grid container>
          <Typography variant="body1" className={classes.title}>
            Your documents
          </Typography>
        </Grid>
        <Grid container justify="flex-end">
          <Box>
            <input
              // accept="image/*"
              name="documents"
              style={{ display: "none" }}
              id="contained-button-file"
              multiple
              type="file"
              accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
              //   onChange={(event) => {
              //     Object.values(event.target.files).map((imageFile) => {
              //         if (imageFile.name.match(/\.(jpg|jpeg|png|doc|docx|pdf)$/)) {
              //             setOrganisationFile((prev) => [...prev, event.target.files])
              //         } else {
              //             alert('Invalid file type..!');
              //         }
              //     })
              // }}
              onChange={(e) => {
                uploadDoc(e);
              }}
            // accept="application/pdf"
            />
            <label htmlFor="contained-button-file">
              <Button
                disableElevation
                style={{ width: "120px", height: "39px", textTransform: "initial" }}
                startIcon={<CloudUploadIcon />}
                variant="contained"
                color="secondary"
                component="span"
              >
                Upload
              </Button>
            </label>
          </Box>
        </Grid>

        <Grid container>
          
          <Grid xs={12}>
            {supportingDocuments.length > 0?
              supportingDocuments.map((item, i) => {
                return <React.Fragment>
                  <Grid
                    key={item.id}
                    container
                    direction="row"
                    spacing={2}
                    alignItem="center"

                  >
                    <Grid item xs={6} >
                      <DocCard key={i} title={item.name} link={item.url} />
                    </Grid>
                    <Grid item xs={1}>
                      <DeleteIcon
                        //  style={{color:"#3B86FF"}}
                        onClick={() => {
                          setcurrentID(item.id);
                          handleClickConfirmationOpen();
                        }}
                        variant="outlined"
                      />
                    </Grid></Grid>
                </React.Fragment>;
              }):<Typography>No records found</Typography>}
          </Grid>
        </Grid>
        { <Grid container>
          <Typography variant="body1" className={classes.title} style={{marginTop:"1rem",marginBottom:"2rem"}}>
            Program documents
          </Typography>
          <Grid xs={12}>
            {
             programDocuments.length>0? programDocuments.map((item, i) => {
                return <React.Fragment>
                  <Grid
                    key={item.id}
                    container
                    direction="row"
                    spacing={2}
                    alignItem="center"

                  >
                    <Grid item xs={6} >
                      <DocCard key={i} title={item.name} link={item.url} />
                    </Grid>
                    {/* <Grid item xs={1}>
                      <DeleteIcon
                        //  style={{color:"#3B86FF"}}
                        onClick={() => {
                          setcurrentID(item.id);
                          handleClickConfirmationOpen();
                        }}
                        variant="outlined"
                      />
                    </Grid> */}
                    </Grid>
                </React.Fragment>;
              }):<Typography>No records found</Typography>
              }
          </Grid>
        </Grid>}
      </Container>
      {/* <Box mt={5}>
        <Grid container direction="row" spacing={2} alignItem="center">
          <Grid item xs={4}>
            {supportingDocuments.length > 0 &&
              supportingDocuments.map((option) => {
                return (
                  <Box border={1} px={2} py={2} mb={2}>
                    <Grid
                      key={option.id}
                      container
                      direction="row"
                      spacing={2}
                      alignItem="center"
                      justify="space-between"
                    >
                      <Grid item xs={9}>
                        <Link href={option.url} target="_blank">
                          <Typography variant="h6" style={{ color: "#4D4F5C" }}>
                            <Box textOverflow="ellipsis" overflow="hidden">
                              {option.name}
                            </Box>
                          </Typography>
                        </Link>
                      </Grid>
                      <Grid item xs={1}>
                        <Box>
                          <DeleteIcon
                            onClick={() => {
                              setcurrentID(option.id);
                              handleClickConfirmationOpen();
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                );
              })}
          </Grid>
        </Grid>
      </Box> */}
      <Dialog
        onClose={handleConfirmationClose}
        aria-labelledby="confirmation-dialog-title"
        open={confirmationDialogOpen}
        maxWidth={maxWidth}
      >
        <DialogContent>
          <Box p={4}>
            <Typography variant="h5">
              <Box textAlign="center">Are you sure to delete?</Box>
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions
          disableSpacing={true}
          style={{ justifyContent: "center" }}
        >
          <Box px={4} pb={2}>
            <Button variant="contained" onClick={handleConfirmationClose}>
              No
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                handleConfirmationClose();
                deleteDoc(currentID);
              }}
              style={{ marginLeft: 10 }}
            >
              Yes
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {loading && <CircularIndeterminate />}
    </div>
  );
}

export default SupportingDocs;

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
}));
